// webapp/frontend/src/main.js
import { createApp } from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import pinia from './stores'
import PlotlyPlugin from './plugins/plotly'
import PrimeVuePlugin from './plugins/primevue'
import { useAuthStore } from './stores/auth'

// AG Grid Enterprise and license
import 'ag-grid-enterprise'
import { LicenseManager } from 'ag-grid-enterprise'
LicenseManager.setLicenseKey('[TRIAL]_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-094359}_is_granted_for_evaluation_only___Use_in_production_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_purchasing_a_production_key_please_contact_info@ag-grid.com___You_are_granted_a_{Single_Application}_Developer_License_for_one_application_only___All_Front-End_JavaScript_developers_working_on_the_application_would_need_to_be_licensed___This_key_will_deactivate_on_{14 October 2025}____[v3]_[0102]_MTc2MDM5NjQwMDAwMA==beb8d54a4d6491a36d345e03edef69f5')
// LicenseManager.setLicenseKey('[TRIAL]_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-092283}_is_granted_for_evaluation_only___Use_in_production_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_purchasing_a_production_key_please_contact_info@ag-grid.com___You_are_granted_a_{Single_Application}_Developer_License_for_one_application_only___All_Front-End_JavaScript_developers_working_on_the_application_would_need_to_be_licensed___This_key_will_deactivate_on_{14 September 2025}____[v3]_[0102]_MTc1NzgwNDQwMDAwMA==9e87e5dbbd2e65bc37d2fcdc9f0929cc')

// Import global styles
import '@/assets/styles/variables.css'

// Import AG Grid styles
import 'ag-grid-community/styles/ag-grid.css'
import '@/assets/styles/ag-grid-theme.css'



// Enable devtools in development
const app = createApp(App)
app.config.devtools = true
app.config.performance = true

// Install plugins
app.use(pinia)
app.use(router)
app.use(store)
app.use(vuetify)
app.use(PlotlyPlugin)
app.use(PrimeVuePlugin)

// Removed AG Grid Enterprise import and license handling to avoid console messages

// Initialize authentication state
const authStore = useAuthStore()
authStore.initializeAuth()

// Mount the app
app.mount('#app')